import { definePreset } from "@primeng/themes";
import Material from "@primeng/themes/material";

const ChevTheme = definePreset(Material, {
  semantic: {
    primary: {
      50: "#E3F2FD",
      100: "#BBDEFB",
      200: "#90CAF9",
      300: "#2196f3",
      400: "#4baaf5",
      500: "#2196f3",
      600: "#1E88E5",
      700: "#1976D2",
      800: "#1565C0",
      900: "#0D47A1",
      950: "#072451",
    },
  },
  components: {
    button: {
      borderRadius: "0",
    },
    datatable: {
      headerCell: {
        selectedColor: "#2196f3",
      },
    },
    tag: {
      fontSize: "1.5rem",
      roundedBorderRadius: "border.radius.none",
    },
    inputtext: {
      fontSize: "1.5rem",
    },
    tieredmenu: {
      background: "rgb(0, 102, 178)",
      borderRadius: "none",
      borderColor: "transparent",
      shadow: "0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12)",
      list: {
        padding: "0.25rem 0",
        gap: "0",
      },
      item: {
        color: "#ffffff",
        focusBackground: "rgba(255, 255, 255, 0.15)",
        focusColor: "#ffffff",
        activeBackground: "rgba(255, 255, 255, 0.15)",
        activeColor: "#ffffff",
        padding: "0.75rem 1rem",
        borderRadius: "0",
        icon: {
          color: "#ffffff",
          focusColor: "#ffffff",
          activeColor: "#ffffff",
        },
      },
      submenu: {
        mobileIndent: "1rem",
      },
      submenuIcon: {
        color: "#ffffff",
        focusColor: "#ffffff",
        activeColor: "#ffffff",
      },
      separator: {
        borderColor: "rgba(255, 255, 255, 0.2)",
      },
    },
    toggleswitch: {
      height: "2rem",
      width: "3rem",
      gap: "0.2rem",
      borderWidth: "0",
      handle: {
        size: "1.4rem",
      },
      colorScheme: {
        light: {
          checkedBackground: "#2196f3",
          checkedHoverBackground: "#0d89ec",
          handle: {
            checkedBackground: "#ffffff",
            checkedHoverBackground: "#ffffff",
          },
        },
      },
    },
    floatlabel: {
      active: {
        fontSize: "1rem",
      },
    },
    togglebutton: {
      borderRadius: "none",
      checkedColor: "#ffffff",
      colorScheme: {
        light: {
          checkedBackground: "#2196f3",
        },
      },
    },
    selectbutton: {
      borderRadius: "0px",
    },
    tabmenu: {
      item: {
        padding: "0px",
        color: "#4baaf5",
      },
    },
  },
});

export default ChevTheme;
